export enum SUBSCRIPTION_STATUS {
  SUCCESS = 'SUCCESS',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  EXPIRED = 'EXPIRED',
  CANCELLED = 'CANCELLED',
  FAILED = 'FAILED',
  RENEWAL_PENDING = 'RENEWAL_PENDING',
}
